// src/api/utils/errorCatalog.ts

/**
 * Centralized Error Catalog
 *
 * Single source of truth for all error codes and API names.
 * Use these constants instead of string literals for consistency.
 */

/**
 * API/service identifiers for error tracking
 */
export const ApiNames = {
  CHAT_API: "chat_api",
  CLASSIFICATION_API: "classification_api",
  CONTRACT_ANALYSIS_API: "contract_analysis_api",
  CONTRACT_SUMMARY_API: "contract_summary_api",
  EXECUTED_CONTRACTS_API: "executed_contracts_api",
  FEEDBACK_API: "feedback_api",
  GENERAL_AGENT_API: "general_agent_api",
  RISK_DISTRIBUTION_API: "risk_distribution_api",
  DRAFTING_ASSISTANT_API: "drafting_assistant_api",
  WORD_API: "word_api",
} as const;

export type ApiName = (typeof ApiNames)[keyof typeof ApiNames];

/**
 * Error codes for all error types
 */
export const ErrorCodes = {
  // Network/Client errors
  NETWORK_ERROR: "network_error",
  INVALID_JSON_ERROR: "invalid_json_error",
  UNKNOWN_ERROR: "unknown_error",
  REQUEST_CANCELLED: "request_cancelled",
  NO_RESPONSE_BODY: "no_response_body",
  NO_RESPONSE_READER: "no_response_reader",
  STREAMING_READ_ERROR: "streaming_read_error",
  STREAMING_ERROR: "streaming_error",

  // Word API errors
  DOCUMENT_READ_ERROR: "document_read_error",
  GET_SELECTION_ERROR: "get_selection_error",
  GET_SELECTED_TEXT_ERROR: "get_selected_text_error",
  INSERT_TEXT_ERROR: "insert_text_error",
  INSERT_TEXT_WITH_FORMATTING_ERROR: "insert_text_with_formatting_error",
  GET_FILE_BYTES_ERROR: "get_file_bytes_error",
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
